
import {Component, Vue} from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import {RequestPaging} from "@/utils/util";
import {apiCollectionLists, apiCollectionDel} from '@/api/collection'
import {apiNewsShopLists} from "@/api/shop";

@Component({
  components: {
    lsPagination
  }
})
export default class CollectionList extends Vue {
  pager: RequestPaging = new RequestPaging();
  shopData: any[] = []
  searchObj = {
    sid: "",
    cumulative: "",
    goods: "",
    buyer: "",
    tel: "",
  };
  // 格式化时间戳为可读时间
  formatTime(timestamp: number): string {
    if (!timestamp) return '-';
    const date = new Date(timestamp * 1000);
    return date.toLocaleString();
  }

  async getLists(): Promise<void> {
    this.pager.request({
      callback: apiCollectionLists,
      params: this.searchObj
    });
  }
  async getShopListsFn(): Promise<void> {
    const res: any = await apiNewsShopLists({
      page_no: 1,
      page_size: 100,
    })
    this.shopData = res.data;
  }
  async onDelete(row: any): Promise<void> {
    await this.$confirm('确定要删除该采集分类吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });

    await apiCollectionDel({id: row.id});
    this.$message.success('删除成功');
    this.getLists();
  }

  created() {
    this.getLists();
    // 获取商城列表是数据
    this.getShopListsFn()
  }
}
